import { render, staticRenderFns } from "./VegetativeMonitoringSpecimenInfo.vue?vue&type=template&id=153ddfb0"
import script from "./VegetativeMonitoringSpecimenInfo.vue?vue&type=script&lang=js"
export * from "./VegetativeMonitoringSpecimenInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports